var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0877 16.3583L10.6773 1.975C10.5633 1.78434 10.3577 1.66734 10.1355 1.66667H9.88548C9.6633 1.66734 9.4577 1.78434 9.34369 1.975L0.916693 16.3583C0.808449 16.5556 0.808449 16.7944 0.916693 16.9917L1.03339 17.1833C1.14141 17.381 1.34987 17.5029 1.57518 17.5H18.4292C18.6545 17.5029 18.8629 17.381 18.971 17.1833L19.0877 16.9917C19.1959 16.7944 19.1959 16.5556 19.0877 16.3583ZM10.8357 13.75C10.8357 13.9801 10.6491 14.1667 10.4189 14.1667H9.58541C9.35524 14.1667 9.16865 13.9801 9.16865 13.75V12.9167C9.16865 12.6865 9.35524 12.5 9.58541 12.5H10.4189C10.6491 12.5 10.8357 12.6865 10.8357 12.9167V13.75ZM10.6523 10.65C10.6396 10.7552 10.5499 10.8341 10.4439 10.8333H9.5604C9.45442 10.8341 9.36474 10.7552 9.35202 10.65L9.01861 7.96667C9.00423 7.84779 9.04171 7.72847 9.12148 7.63915C9.20125 7.54983 9.31561 7.49913 9.43538 7.5H10.569C10.6887 7.49913 10.8031 7.54983 10.8829 7.63915C10.9626 7.72847 11.0001 7.84779 10.9857 7.96667L10.6523 10.65Z",
    fill: "#FCB704"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d2f4d031cb8547e608568fcff6b8247d.svg";
export { ForwardRef as ReactComponent };